const industries = [
  { value: "0", label: "Banking & Financial Services" },
  { value: "1", label: "Engineering & Construction" },
  { value: "2", label: "Education" },
  { value: "3", label: "Government & Public Safety" },
  { value: "4", label: "Forestry Products" },
  { value: "5", label: "Consumer Packaged Goods" },
  { value: "6", label: "Keller Enterprises" },
  { value: "7", label: "Manufacturing & Fabrication" },
  { value: "8", label: "Hospitality & Property Mgt" },
  { value: "9", label: "Retail & Consumer Services" },
  { value: "10", label: "Science & Technology" },
  { value: "11", label: "Sales & Marketing" },
  { value: "12", label: "Social Services" },
  { value: "13", label: "Trades" },
  { value: "14", label: "Logistics & Distribution" },
  { value: "15", label: "Property Mgt" },
];

export default industries;
